export default __webpack_public_path__ + "static/spinner-930789a6939fa6f7fec356fb896c56d7.svg";